import { render, staticRenderFns } from "./eAristoStudentRootView.vue?vue&type=template&id=f2282e06"
import script from "./eAristoStudentRootView.vue?vue&type=script&lang=js"
export * from "./eAristoStudentRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports